import { ISplitState } from '@splitsoftware/splitio-redux/lib/types';
import { SPLIT_IO_API_KEYS } from '../constants';

const getSplitioKey = (prodKey: string | null) => {
    if (prodKey) {
        return prodKey;
    }
    const { hostname } = window.location;
    return hostname.includes('dev')
        ? SPLIT_IO_API_KEYS.dev
        : SPLIT_IO_API_KEYS.evbqa;
};

export const getSplitioClient = (eventId: string, prodKey: string | null) => ({
    core: {
        authorizationKey: getSplitioKey(prodKey),
        key: eventId, // Unique id to track anonymous users
    },
    startup: {
        readyTimeout: 1.5,
    },
});

export const createMockSplitState: (flags: any) => ISplitState = (
    flags: any,
) => {
    const treatments: any = Object.fromEntries(
        Object.keys(flags).map((key) => [
            key,
            { 1: { treatment: flags[key] } },
        ]),
    );
    return {
        isReady: true,
        isReadyFromCache: true,
        isTimedout: true,
        hasTimedout: true,
        isDestroyed: true,
        lastUpdate: -1,
        treatments,
    };
};

/* Split IO keys */
export const ENABLE_INTERSTITIAL_STEP =
    'login_as_interstitial_step_in_checkout';

export const PAYMENT_OPTIONS_LAST_ELEMENT =
    'checkout_payments_options_last_element';

export const ENABLE_STATSIG_APPLE_PAY =
    'checkout_enable_statsig_experiment_with_apple_pay';
